export function Education() {
  return (
    <section id="education" className="section">
      <div className="section-inner">
        <h2 className="section-title">Education</h2>
        <div className="education-card">
          <div className="education-icon">
            <svg
              width="28"
              height="28"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M22 10v6M2 10l10-5 10 5-10 5z" />
              <path d="M6 12v5c0 2 4 3 6 3s6-1 6-3v-5" />
            </svg>
          </div>
          <div>
            <div className="education-school">University of Notre Dame</div>
            <div className="education-degree">
              BS, Computer Science — Summa Cum Laude
            </div>
            <div className="education-meta">1990 – 1994</div>
            <div className="education-honors">
              <span className="education-honor-badge">Summa Cum Laude</span>
              <span className="education-honor-badge">Tau Beta Pi</span>
              <span className="education-honor-badge">
                Outstanding CS Senior Award
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
